module.exports = __webpack_public_path__ + "static/media/Carosel HO 1.edf5b303.svg";